import { render, staticRenderFns } from "./registerConfig.vue?vue&type=template&id=3f7d3137&scoped=true"
import script from "./registerConfig.vue?vue&type=script&lang=js"
export * from "./registerConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7d3137",
  null
  
)

export default component.exports